import logo from './logo.svg';
import './App.css';
import PrivacyPolicy from './PrivacyPolicy.js';

function App() {
  return (
    <div className="App">
      <PrivacyPolicy />
    </div>
  );
}

export default App;
